export default "__VITE_ASSET__69126af4__"